import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedSymbol } from '../../../store/Slices/historySlice';
import { MenuItem, MenuList, Popover, Tooltip } from '@mui/material';
import { ThemeContext } from '../../../context/ThemeContext';
import { MdOutlineCurrencyExchange } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import CheckIcon from "@mui/icons-material/Check"

export default function HistoryMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { darkMode } = useContext(ThemeContext)
    const [uniqueSymbols, setUniqueSymbols] = useState([]);
    const selectedSymbol = useSelector((state) => state.history.selectedSymbol)
    const filteredHistory = useSelector((state) => state.history.filteredHistory)
    const handleOpenFilterMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseFilterMenu = () => {
        setAnchorEl(null);
    };
    const handleSelectSymbol = (symbol) => {
        dispatch(setSelectedSymbol(symbol === "All" ? "" : symbol));
        setAnchorEl(null);
    };

    useEffect(() => {
        const symbols = [...new Set(filteredHistory?.map(
            trade => trade.symbolData?.name || trade.symbolName
        ))].filter(Boolean);
        setUniqueSymbols(symbols);
    }, [filteredHistory]);
    return (
        <>
            <Tooltip title={t('filterbySymbol')}><MdOutlineCurrencyExchange onClick={handleOpenFilterMenu} style={{ cursor: 'pointer', fontSize: 18, color: darkMode ? "var(--lightText)" : "var(--darkText)" }} /></Tooltip>
            <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleCloseFilterMenu} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                <MenuList sx={{ backgroundColor: darkMode ? '#202933' : '#fff' }}>
                    <MenuList sx={{ backgroundColor: darkMode ? "#202933" : "#fff", }}>
                        {uniqueSymbols?.length > 0 && (
                            <MenuItem onClick={() => handleSelectSymbol("All")} sx={{ fontSize: 13.5, }}>{t('allSymbols')}</MenuItem>
                        )}
                        {uniqueSymbols.length > 0 ? uniqueSymbols.map((symbol, index) => (
                            <MenuItem key={index} onClick={() => handleSelectSymbol(symbol)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between" }}>{symbol}{selectedSymbol === symbol && <CheckIcon fontSize="small" sx={{ fontSize: 18, color: "#4597ff" }} />}</MenuItem>
                        )) : (<MenuItem disabled sx={{ fontSize: 13.5 }}>{t('NoSymbolsAvailable')}</MenuItem>)}
                    </MenuList>
                </MenuList>
            </Popover>
        </>
    )
}
